var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.shown)?_c(_setup.IModal,{attrs:{"close-on-click-modal":false,"close-on-press-escape":false,"lock-scroll":true,"show-close":false},model:{value:(_setup.shown),callback:function ($$v) {_setup.shown=$$v},expression:"shown"}},[_c(_setup.activeComponent,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }